const resume = {
  "basics": {
    "name": "GuoXiaoyang",
    "label": "Web Software Engineer",
    "picture": "https://avatars2.githubusercontent.com/u/8994590?s=460&v=4",
    "email": "guoxiaoang0925@gmail.com",
    "phone": "155XXXX3279",
    "website": "guoxiaoyang.xyz",
    "summary": [
      "Love programming and strong self-leaning skills", 
      "Acquired FCC front end and data visualization certificates and completed multiple backend projects", 
      "Familiar with Web application development, have the ability to complete web applications independently from UI design to back-end service building",
      "Currently focusing on the React technology stack, hoping to be a full-stack developer and going deep into one certain skill",
      "Excellent written and verbal communication skills"
    ],
    "location": {
      "address": "East Wangzhuang district" ,
      "postalCode": "100190",
      "city": "Beijing",
      "countryCode": "China",
      "region": "Haidian Distrcit"
    },
    "profiles": [
      {
        "network": "github",
        "username": "GuoXiaoyang",
        "url": "https://github.com/GuoXiaoyang"
      },
      {
        "network": "instagram",
        "username": "GuoXiaoyang",
        "url": "https://www.instagram.com/mrguo_missshaw"
      },
      {
        "network": "envelope",
        "username": "GuoXiaoyang",
        "url": "mailto:guoxiaoyang0925@gmail.com"
      },
      {
        "network": "home",
        "username": "GuoXiaoyang",
        "url": "http://blog.guoxiaoyang.xyz"
      },
      {
        "network": "linkedin-square",
        "username": "GuoXiaoyang",
        "url": "http://www.linkedin.com/in/guoxiaoyang/"
      },
      {
        "network": "medium",
        "username": "GuoXiaoyang",
        "url": "https://medium.com/@guoxiaoyang0925"
      },
      {
        "network": "free-code-camp",
        "username": "GuoXiaoyang",
        "url": "https://www.freecodecamp.org/guoxiaoyang"
      }
    ]
  },
  "work": [
    {
      "company": "Individual Developer",
      "position": "Web Software Engineer",
      "website": "http://blog.guoxiaoyang.xyz",
      "startDate": "2017-07-01",
      "endDate": "Present",
      "summary": "Beijing",
      "highlights": [
        "Acquire the FreeCodeCampus front-end and data-visualization certificates",
        "Build multiple Web applications based on the React technology stack independently and make adaptive layout for mobile devices",
        "Be familiar with the Web development and deploy process, and launch a Web application based on the technology stack of MERN (MongoDB, Express, React, and Node.js) to realize the voting system based on IP or authentication user."
      ]
    },
    {
      "company": "Huawei Beijing Insititute",
      "position": "Image Alogorithm Engineer",
      "website": "http://huawei.com",
      "startDate": "2016-06-15",
      "endDate": "2017-04-23",
      "summary": "Beijing",
      "highlights": [
        "Involved in camera algorithms tuning for serveral high-end mobiles,optimize the image noise characteristics",
        "Involved in the preresearch and analysis of mobile camera imaging algorithms and output several test plans and reports", 
        "Lead the small team to complete the image quality debugging and verification of huawei's mid-end mobile phone, responsible for team task decomposition, goal setting, progress report and final report output"
      ]
    },
    {
      "company": "Image Algorithm Engineer Intern",
      "position": "GE Healthcare",
      "website": "http://blog.guoxiaoyang.xyz",
      "startDate": "2015-05-01",
      "endDate": "2015-10-01",
      "summary": "Beijing",
      "highlights": [
        "Optical flow estimation of 3D CT images based on HS algorithm and TV-L1 algorithm",
        "Improve the algorithm efficiency about 10 times through OpenCL parallel computing"
      ]
    }
  ],
  "volunteer": [
    {
      "organization": "<ORGANIZATION_NAME>",
      "position": "<POSITION>",
      "website": "<WEBSITE>",
      "startDate": "2016-06-15",
      "endDate": "2017-04-23",
      "summary": "<SUMMARY>",
      "highlights": ["<HIGHTLIGHT_1>", "<HIGHTLIGHT_2>", "<HIGHTLIGHT_3>"]
    }
  ],
  "education": [
    {
      "institution": "University of Chinese Academy of Sciences",
      "area": "Signal and Information Processing",
      "studyType": "Master",
      "startDate": "2013-09-01",
      "endDate": "2016-06-01",
      "gpa": "3.2",
      "summary": "Master",
      "courses": ["Signal Processing", "Digital Image Processing", "Stochastic Process"]
    },
    {
      "institution": "Wuhan University",
      "area": "Electronic Information Science and Technology",
      "studyType": "Bachelor",
      "startDate": "2009-09-01",
      "endDate": "2013-06-01",
      "gpa": "3.2",
      "summary": "Bachelor",
      "courses": ["Computer network", "C++ language design", "Advanced mathematics"]
    }
  ],
  "awards": [
    {
      "title": "<AWARD_TITLE>",
      "date": "<DATE>",
      "awarder": "<AWARDER>",
      "summary": "<SUMMARY>"
    }
  ],
  "projects": [
    {
      "name": "Wiki Search",
      "publisher": "GuoXiaoyang",
      "category": "Web",
      "releaseDate": "2017-07-31",
      "website": "https://guoxiaoyang.github.io/WikipediaViewer/",
      "summary": "A wiki search app with wiki API",
      "image": {
        "modal": "./images/WikipediaViewer.png",
        "thumb": "./images/WikipediaViewer.png"
      },
      "keywords": ["Angular", "API","Wiki"]
    },
    {
      "name": "Calculator",
      "publisher": "GuoXiaoyang",
      "category": "Web",
      "releaseDate": "2017-08-11",
      "website": "https://guoxiaoyang.github.io/JavaScript_Calculator/",
      "summary": "Calculator application based on React",
      "image": {
        "modal": "./images/Calculator.png",
        "thumb": "./images/Calculator.png"
      },
      "keywords": ["React", "Calculator"]
    },
    {
      "name": "Simon Game",
      "publisher": "GuoXiaoyang",
      "category": "Web",
      "releaseDate": "2017-08-20",
      "website": "https://guoxiaoyang.github.io/Simon-Game/",
      "summary": "Simon Game based on React",
      "image": {
        "modal": "./images/SimonGame.png",
        "thumb": "./images/SimonGame.png"
      },
      "keywords": ["React", "Game"]
    },
    {
      "name": "Pomodoro Clock",
      "publisher": "GuoXiaoyang",
      "category": "Web",
      "releaseDate": "2017-09-08",
      "website": "https://guoxiaoyang.github.io/typescript-react-pomodoro/",
      "summary": "A customed pomodoro clock based on React",
      "image": {
        "modal": "./images/PomodoroClock.png",
        "thumb": "./images/PomodoroClock.png"
      },
      "keywords": ["Typescript", "React", "Pomodoro"]
    },
    {
      "name": "Game of Life",
      "publisher": "GuoXiaoyang",
      "category": "Web",
      "releaseDate": "2017-09-15",
      "website": "https://guoxiaoyang.github.io/game-of-life/",
      "summary": "Game of Life based on React",
      "image": {
        "modal": "./images/GameOfLife.gif",
        "thumb": "./images/GameOfLife.png"
      },
      "keywords": ["React", "Game"]
    },
    {
      "name": "Dungeon Crawler Game",
      "publisher": "GuoXiaoyang",
      "category": "Web",
      "releaseDate": "2017-09-22",
      "website": "https://guoxiaoyang.github.io/DungeonCrawlerGame/",
      "summary": "Dungeon Crawler Game based on React",
      "image": {
        "modal": "./images/CrawlerGame.gif",
        "thumb": "./images/CrawlerGame.png"
      },
      "keywords": ["React", "Game"]
    },
    {
      "name": "Data Visualization",
      "publisher": "GuoXiaoyang",
      "category": "Web",
      "releaseDate": "2017-09-30",
      "website": "https://guoxiaoyang.github.io/DataVisualizationProjects/",
      "summary": "Data Visualization based on React and D3.js",
      "image": {
        "modal": "./images/DataVisualization.png",
        "thumb": "./images/DataVisualization.png"
      },
      "keywords": ["React", "D3","Data Visualization"]
    },
    {
      "name": "VotingApp",
      "publisher": "GuoXiaoyang",
      "category": "Web",
      "releaseDate": "2017-10-15",
      "website": "http://voting.guoxiaoyang.xyz",
      "summary": "A voting app based on the React, Node, Express, users can register and create polls; Polls can also be voted with IP or authenticated user; Votes are visualized with Pie Charts; each user or IP can only vote once on single poll",
      "image": {
        "modal": "./images/VotingApp.png",
        "thumb": "./images/VotingApp.png"
      },
      "keywords": ["React", "Node", "Voting"]
    }
  ],
  "skills": [
    {
      "title": "Programming Language",
      "description": [
        "Familiar with JavaScript/HTML/CSS，Python", 
        "Familiar with React/Redux and relative technology stack", 
        "Familiar with Node.js",
        "Focused on fullstack development with React-Node currently"
      ],
      "skillDetails": [
        {
          "name": "JavaScript",
          "level": "80",
          "keywords": ["<KEYWORD_1>", "<KEYWORD_2>", "<KEYWORD_3>"]
        },
        {
          "name": "Python",
          "level": "60",
          "keywords": ["<KEYWORD_1>", "<KEYWORD_2>", "<KEYWORD_3>"]
        },
        {
          "name": "Matlab",
          "level": "80",
          "keywords": ["<KEYWORD_1>", "<KEYWORD_2>", "<KEYWORD_3>"]
        },
        {
          "name": "C++",
          "level": "60",
          "keywords": ["<KEYWORD_1>", "<KEYWORD_2>", "<KEYWORD_3>"]
        }
      ]
    },
    {
      "title": "Database Systems",
      "description": [
        "Familiar with MongoDB"
      ],
      "skillDetails": [
        {
          "name": "MongoDB",
          "level": "70",
          "keywords": ["<KEYWORD_1>", "<KEYWORD_2>", "<KEYWORD_3>"]
        }
      ]
    },
    {
      "title": "Design skills",
      "description": [
        "Familiar with PS/AI, have the experience of collaboration with UI design and front-end"
      ],
      "skillDetails": [
        {
          "name": "PhotoShop",
          "level": "70",
          "keywords": ["<KEYWORD_1>", "<KEYWORD_2>", "<KEYWORD_3>"]
        },
        {
          "name": "Illustrator",
          "level": "70",
          "keywords": ["<KEYWORD_1>", "<KEYWORD_2>", "<KEYWORD_3>"]
        }
      ]
    }
  ],
  "languages": [
    {
      "name": "<LANGUAGE_NAME>",
      "level": "<LANGUAGE_LEVEL>"
    }
  ],
  "interests": [
    {
      "name": "<INTEREST_NAME>",
      "keywords": ["<KEYWORD_1>", "<KEYWORD_2>", "<KEYWORD_3>"]
    }
  ],
  "references": [
    {
      "name": "Self Evaluation",
      "position": "Web Software Engineer",
      "company": "Individual Developer",
      "reference": "Review the past, sum up your experience and look forward to the future"
    },
    {
      "name": "Self Evaluation",
      "position": "Web Software Engineer",
      "company": "Individual Developer",
      "reference": "To make your own life"
    },
    {
      "name": "Self Evaluation",
      "position": "Web Software Engineer",
      "company": "Individual Developer",
      "reference": "Be stronger"
    }
  ]
};

export default resume;


// WEBPACK FOOTER //
// ./src/template/resume.en_US.js